export const LIST_MCU_PROJECT_REQUEST = 'LIST_MCU_PROJECT_REQUEST'
export const LIST_MCU_PROJECT_SUCCESS = 'LIST_MCU_PROJECT_SUCCESS'
export const LIST_MCU_PROJECT_FAIL = 'LIST_MCU_PROJECT_FAIL'

export const LIST_MCU_PROJECT_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_SUMMARY_FAIL = 'LIST_MCU_PROJECT_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_REQUEST = 'CREATE_MCU_PROJECT_REQUEST'
export const CREATE_MCU_PROJECT_SUCCESS = 'CREATE_MCU_PROJECT_SUCCESS'
export const CREATE_MCU_PROJECT_FAIL = 'CREATE_MCU_PROJECT_FAIL'

export const DETAIL_MCU_PROJECT_REQUEST = 'DETAIL_MCU_PROJECT_REQUEST'
export const DETAIL_MCU_PROJECT_SUCCESS = 'DETAIL_MCU_PROJECT_SUCCESS'
export const DETAIL_MCU_PROJECT_FAIL = 'DETAIL_MCU_PROJECT_FAIL'

export const DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_REQUEST = 'DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_REQUEST'
export const DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_SUCCESS = 'DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_SUCCESS'
export const DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_FAIL = 'DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_FAIL'

export const DETAIL_MCU_PROJECT_SETUP_REQUEST = 'DETAIL_MCU_PROJECT_SETUP_REQUEST'
export const DETAIL_MCU_PROJECT_SETUP_SUCCESS = 'DETAIL_MCU_PROJECT_SETUP_SUCCESS'
export const HISTORY_MCU_PROJECT_REQUEST = 'HISTORY_MCU_PROJECT_REQUEST'
export const HISTORY_MCU_PROJECT_SUCCESS = 'HISTORY_MCU_PROJECT_SUCCESS'
export const HISTORY_MCU_PROJECT_FAIL = 'HISTORY_MCU_PROJECT_FAIL'

export const DETAIL_MCU_PROJECT_SETUP_FAIL = 'DETAIL_MCU_PROJECT_SETUP_FAIL'

export const UPDATE_MCU_PROJECT_REQUEST = 'UPDATE_MCU_PROJECT_REQUEST'
export const UPDATE_MCU_PROJECT_SUCCESS = 'UPDATE_MCU_PROJECT_SUCCESS'
export const UPDATE_MCU_PROJECT_FAIL = 'UPDATE_MCU_PROJECT_FAIL'

export const UPDATE_MCU_PROJECT_SUTUP_REQUEST = 'UPDATE_MCU_PROJECT_SUTUP_REQUEST'
export const UPDATE_MCU_PROJECT_SUTUP_SUCCESS = 'UPDATE_MCU_PROJECT_SUTUP_SUCCESS'
export const UPDATE_MCU_PROJECT_SUTUP_FAIL = 'UPDATE_MCU_PROJECT_SUTUP_FAIL'

export const DELETE_MCU_PROJECT_REQUEST = 'DELETE_MCU_PROJECT_REQUEST'
export const DELETE_MCU_PROJECT_SUCCESS = 'DELETE_MCU_PROJECT_SUCCESS'
export const DELETE_MCU_PROJECT_FAIL = 'DELETE_MCU_PROJECT_FAIL'

export const EXPORT_MCU_PROJECTS_REQUEST = 'EXPORT_MCU_PROJECTS_REQUEST'
export const EXPORT_MCU_PROJECTS_SUCCESS = 'EXPORT_MCU_PROJECTS_SUCCESS'
export const EXPORT_MCU_PROJECTS_FAIL = 'EXPORT_MCU_PROJECTS_FAIL'

export const RESET_MCU_PROJECT = 'RESET_MCU_PROJECT'

export const DUPLICATE_MCU_PROJECTS_REQUEST = 'DUPLICATE_MCU_PROJECTS_REQUEST'
export const DUPLICATE_MCU_PROJECTS_SUCCESS = 'DUPLICATE_MCU_PROJECTS_SUCCESS'
export const DUPLICATE_MCU_PROJECTS_FAIL = 'DUPLICATE_MCU_PROJECTS_FAIL'

export const LIST_MCU_PACKAGE_SUMMARY_REQUEST = 'LIST_MCU_PACKAGE_SUMMARY_REQUEST'
export const LIST_MCU_PACKAGE_SUMMARY_SUCCESS = 'LIST_MCU_PACKAGE_SUMMARY_SUCCESS'
export const LIST_MCU_PACKAGE_SUMMARY_FAIL = 'LIST_MCU_PACKAGE_SUMMARY_FAIL'

export const LIST_EXPORT_CLIENT_PROJECT_REQUEST = 'LIST_EXPORT_CLIENT_PROJECT_REQUEST'
export const LIST_EXPORT_CLIENT_PROJECT_SUCCESS = 'LIST_EXPORT_CLIENT_PROJECT_SUCCESS'
export const LIST_EXPORT_CLIENT_PROJECT_FAIL = 'LIST_EXPORT_CLIENT_PROJECT_FAIL'

export const DOWNLOAD_EXPORT_CLIENT_PROJECT_REQUEST = 'DOWNLOAD_EXPORT_CLIENT_PROJECT_REQUEST'
export const DOWNLOAD_EXPORT_CLIENT_PROJECT_SUCCESS = 'DOWNLOAD_EXPORT_CLIENT_PROJECT_SUCCESS'
export const DOWNLOAD_EXPORT_CLIENT_PROJECT_FAIL = 'DOWNLOAD_EXPORT_CLIENT_PROJECT_FAIL'

export const DETAIL_MCU_RESULT_CATEGORY_REQUEST = 'DETAIL_MCU_RESULT_CATEGORY_REQUEST'
export const DETAIL_MCU_RESULT_CATEGORY_SUCCESS = 'DETAIL_MCU_RESULT_CATEGORY_SUCCESS'
export const DETAIL_MCU_RESULT_CATEGORY_FAIL = 'DETAIL_MCU_RESULT_CATEGORY_FAIL'
